



























import { Observer } from 'mobx-vue'
import { Component, Provide, Vue } from 'vue-property-decorator'
import { SbStakingViewModel } from '../viewmodel/sb-staking-viewmodel'

@Observer
@Component({
  components: {
    'sb-staking-banner': () => import('../components/sb-staking-banner.vue'),
    'sb-staking-farms': () => import('../components/sb-staking-farms.vue'),

    // dialog
    'sb-stake-dialog': () => import('../dialogs/sb-stake-dialog.vue'),
    'sb-unstake-dialog': () => import('../dialogs/sb-unstake-dialog.vue'),
    'sb-havest-dialog': () => import('../dialogs/sb-havest-dialog.vue'),
    'ste-stake-dialog': () => import('../dialogs/ste-stake-dialog.vue'),
    'ste-unstake-dialog': () => import('../dialogs/ste-unstake-dialog.vue'),
    'ste-havest-dialog': () => import('../dialogs/ste-havest-dialog.vue'),
    //
    'usdt-stake-dialog': () => import('../dialogs/usdt-stake-dialog.vue'),
    'usdt-unstake-dialog': () => import('../dialogs/usdt-unstake-dialog.vue'),
    'usdt-havest-dialog': () => import('../dialogs/usdt-havest-dialog.vue')
  }
})
export default class extends Vue {
  @Provide() vm = new SbStakingViewModel()
}
